module.exports = " <div class=alert :class=\"'alert-' + type\" :class=\"{ 'alert-dismissible': dismissible, fade: animation, in: animation }\" role=alert> <button v-if=dismissible type=button class=close data-dismiss=alert aria-label=Close> <span aria-hidden=true>&times;</span> <span class=sr-only>Close</span> </button> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Common/CallbackAlert.vue
// module id = 639
// module chunks = 0